import { render, staticRenderFns } from "./MostPopularCourseStatistics.vue?vue&type=template&id=64244963&scoped=true"
import script from "./MostPopularCourseStatistics.vue?vue&type=script&lang=ts"
export * from "./MostPopularCourseStatistics.vue?vue&type=script&lang=ts"
import style0 from "./MostPopularCourseStatistics.vue?vue&type=style&index=0&id=64244963&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64244963",
  null
  
)

export default component.exports